/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Form from 'react-bootstrap/Form';
import { MenuItem, Checkbox } from '@material-ui/core';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger } from 'react-bootstrap';
import moment from 'moment';
import {
  CMS_MISMATCH_GRID_LABEL,
  INVOICED,
  NON_INVOICED,
  QUARTER,
  REBATE_PROGRAM,
} from './ConstantData';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { CMSMismatchTabelHeader } from './gridComponent/TableHead';
import {
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { getRebateProgrameList } from '../store/actions';
import { parseDate } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const CmsMismatchDetails = () => {
  const dispatch = useDispatch();
  // useSelector function
  const getCmsMismatchDetails = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.cmsMismatchDetail
  );
  const searchCmsMismatchDetailData = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.cmsMismatchDetailData
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.rebateProgram
  );
  // variable declaration
  const [fullScreenView, setFullScreenView] = useState(false);
  const [cmsMismatchDetailList, setCmsMismatchDetailList] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [rebateProList, setRebateProList] = useState([]);
  const [showFilterAmount, setShowFilterAmount] = useState(false);
  const [filterTotalAmount, setFilterTotalAmount] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // get call on Rebate Programs api
  React.useEffect(() => {
    getRebateProgrameList(
      searchCmsMismatchDetailData?.searchData?.planTypeCd
    ).then((res) => {
      setRebateProList(res);
    });
  }, []);
  // setting CMS Mismatch details list
  React.useEffect(() => {
    let list = [];
    if (
      getCmsMismatchDetails &&
      getCmsMismatchDetails.status === STATUS_MSG &&
      getCmsMismatchDetails.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getCmsMismatchDetails.cmsMisMatchDetailResponseVO)) {
        list = _.map(
          getCmsMismatchDetails.cmsMisMatchDetailResponseVO,
          (val, ind) => ({
            ...val,
            ndc: val.ndc,
            drugName: val.drugName,
            minClaimDt: parseDate(val.minClaimDt),
            numOfUnits: val.numOfUnits,
            numPrescriptions: val.numPrescriptions,
            reimbursementAmt: val.reimbursementAmt,
          })
        );
      }
    }
    setCmsMismatchDetailList(list);
  }, [getCmsMismatchDetails]);
  // setting Rebate programe list
  React.useEffect(() => {
    let list = [];
    if (
      rebateProList?.status === STATUS_MSG &&
      rebateProList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProList.data)) {
        list = _.map(rebateProList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProList]);
  // getReimbursementAmt total
  const getReimbursementAmt =
    cmsMismatchDetailList &&
    cmsMismatchDetailList.length > 0 &&
    cmsMismatchDetailList.map((item) => item.reimbursementAmt);
  const reimbursementAmt =
    getReimbursementAmt &&
    getReimbursementAmt.length > 0 &&
    getReimbursementAmt
      .map((el) => (typeof el === 'string' ? Number(el.slice(1)) : el))
      .reduce((prev, next) => prev + next)
      .toFixed(2);
  const totalReimbursementAmt = reimbursementAmt
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="cms-mismatch-details-component"
    >
      {!fullScreenView && (
        <CustomSeparator parent1="Research" parent2="CMS Mismatch Detail" />
      )}
      {!fullScreenView && (
        <div className="row">
          <div className="col-6 mt-2">
            <fieldset className="custom-fieldset">
              <legend aria-hidden="true" className="d-none" />
              <div className="row">
                <div className="col-6 mui-custom-form">
                  <TextField
                    data-testid="rebate_program-cbi"
                    id="rebate_program"
                    label={REBATE_PROGRAM}
                    fullWidth
                    select
                    disabled
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={searchCmsMismatchDetailData?.rebateProgramCd}
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className="col-4 mui-custom-form">
                  <TextField
                    data-testid="check_quarter_cms_mismatch"
                    id="check_quarter_id_cms_mismatch"
                    label={QUARTER}
                    fullWidth
                    disabled
                    placeholder=""
                    inputProps={{ maxLength: 6 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      searchCmsMismatchDetailData &&
                      searchCmsMismatchDetailData?.searchData &&
                      searchCmsMismatchDetailData?.searchData?.quarterValue
                        ? searchCmsMismatchDetailData?.searchData?.quarterValue
                        : ''
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-6">
            <fieldset className="custom-fieldset">
              <legend>Invoice Status </legend>
              <Form.Group className="d-flex" controlId="formBasicCheckbox">
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  className="mx-2 mr-4"
                  data-testid="cms-mismatch-details-invoiced-check"
                  id="cms-mismatch-details-invoiced-check-id"
                  label={INVOICED}
                  disabled
                  checked={searchCmsMismatchDetailData?.checkValue?.invoiced}
                />
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  data-testid="cms-mismatch-details-nonInvoiced-check"
                  id="cms-mismatch-details-nonInvoiced-check-id"
                  disabled
                  label={NON_INVOICED}
                  checked={searchCmsMismatchDetailData?.checkValue?.nonInvoiced}
                />
              </Form.Group>
            </fieldset>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 frr-log_chk">
          <TableGridWithFeatures
            data-testid="cms-mismatch-details-component-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            columnDefs={CMSMismatchTabelHeader}
            rowData={cmsMismatchDetailList}
            isScrollOn
            exportFile
            animateRows
            sideBar={false}
            hideTotalCount={false}
            fileName={CMS_MISMATCH_GRID_LABEL}
            onFilterData={(data) => {
              if (data?.length > 0) {
                setShowFilterAmount(true);
                const reimbursementData = data?.map((item) => {
                  if (item?.reimbursementAmt) {
                    return parseFloat(
                      item?.reimbursementAmt?.toString().split('$')[1]
                    )?.toFixed(2);
                  }
                  return 0;
                });
                const totalAmount = reimbursementData?.reduce((a, b) => {
                  return parseFloat(a) + parseFloat(b);
                });
                setFilterTotalAmount(
                  parseFloat(totalAmount)
                    ?.toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                );
              } else {
                setFilterTotalAmount(0);
              }
            }}
            showFooterForPDF
            footerVariable={{
              name: 'Total Reimbursement',
              amount: showFilterAmount
                ? filterTotalAmount
                : totalReimbursementAmt,
            }}
            frameworkComponents={{
              DrugNameRenderer: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  cellInfo.value.length > 20
                ) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="labeler-tooltip">{cellInfo.value}</Tooltip>
                      }
                    >
                      <div>
                        {cellInfo.value &&
                          `${cellInfo.value.substring(0, 20)}...`}
                      </div>
                    </OverlayTrigger>
                  );
                }
                return <div>{cellInfo.value}</div>;
              },
              EarliestClaimDate: (cellInfo) => {
                if (cellInfo.value !== null && cellInfo.value !== '')
                  return (
                    <div>{moment(cellInfo.value).format('MM/DD/YYYY')}</div>
                  );
              },
            }}
          />
        </div>
      </div>
      <div
        className="row d-flex mx-4 flex-row-reverse"
        style={{ position: 'absolute', right: '0px', bottom: '1px' }}
      >
        <p className="mx-4 py-3">
          Total Reimbursement: $
          <b>{showFilterAmount ? filterTotalAmount : totalReimbursementAmt}</b>{' '}
        </p>
      </div>
    </div>
  );
};
export default CmsMismatchDetails;
